import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../packages/kiti/components/presentation/Text'
import ControlBar from './ControlBar'
import Separator from '../../../components/helpers/Separator'

const PageHeader = () => {
  const { t } = useTranslation('placeLevels')
  return (
    <Fragment>
      <Grid justify="space-between" align="center" gutter={0.4}>
        <Col flex={3}>
          <Title size="h3" color="dark3" noWrap>
            {t('title')}
          </Title>
        </Col>
        <Col flex={1}>
          <ControlBar />
        </Col>
      </Grid>

      <Separator weight={4} />
    </Fragment>
  )
}

export default PageHeader
